import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import './ItemList.scss';
import {isBrowser, isMobile} from 'react-device-detect';

const ItemsList = ({links, numberOfColumns, actionCallback}) => {
  const [columns, setColumns] = useState(!numberOfColumns ? links.length : numberOfColumns);
  const [gridColumns, setGridColumns] = useState('auto-fill');
  const [maxWidth, setMaxWidth] = useState('100%');

  const updateWindowWidth = () => {
    const gridWidth = (104 + 60) * columns - 60;
    const windowWidthInt = parseInt(window.innerWidth);
    if (windowWidthInt <= gridWidth) {
      setMaxWidth('100%');
      setGridColumns('auto-fill');
    } else {
      setMaxWidth(gridWidth + 'px');
      setGridColumns(columns);
    }
  };

  useEffect(() => {
    updateWindowWidth();
    window.addEventListener('resize', updateWindowWidth);
    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    };
  }, [columns]);

  useEffect(() => {
    setColumns(!numberOfColumns ? links.length : numberOfColumns);
  }, [links]);

  const determineHref = (link) => {
    return actionCallback ? '' : link;
  };

  const item = links.map((link, index) => {
    return (
      <a key={index} href={determineHref(link.href)} onClick={actionCallback ? () => actionCallback(link) : null} className='item-block'>
        {link.showBadge && link.badgeTitle ? <span className='item-badge'>{link.badgeTitle}</span> : null}

        <div className='item-image-wrapper'>
          <Image className='item-image' src={link.image} alt='' />
        </div>

        <span className='item-title'>{link.title}</span>
      </a>
    );
  });

  return (
    <div
      style={{gridTemplateColumns: isBrowser ? `repeat(${gridColumns}, 104px)` : null, maxWidth: isBrowser ? maxWidth : null}}
      className={isBrowser ? 'dalpak-items-container' : 'dalpak-items-container-mobile'}>
      {item}
    </div>
  );
};

export default ItemsList;
